import * as THREE from "three"
import Stats from "stats.js"

import { Camera } from "./Camera"
import { Renderer } from "./Renderer"
import { Sizes } from "./Sizes"
import { Loaders } from "./Loaders"
import { Garments } from "./Garments"
import { Lights } from "./Lights"
import { Environment } from "./Environment"
import { GarmentManager } from "./GarmentManager"
import { Overlay } from "./Overlay"
import { PostProcessing } from "./PostProcessing"
import { Patch } from "./Patch"
import { Pane } from "tweakpane"
import { EnvironmentParticles } from "./EnvironmentParticles"
import { Background } from "./Background"
import { Grain } from "./Grain"
import { DeviceStateManager } from "./DeviceStateManager"
import { GarmentJacket } from "./GarmentJacket"
import { GarmentTShirt } from "./GarmentTShirt"
import { LoadingScreen } from "./LoadingScreen"

// const stats = new Stats()
// stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom)

export const pane = new Pane()
pane.hidden = true

export const patchFolder = pane.addFolder({
  title: "Patch",
  expanded: false,
})
export const postProcessingFolder = pane.addFolder({
  title: "Postprocessing",
  expanded: false,
})

export const environmentParticlesFolder = pane.addFolder({
  title: "Environment Particles",
  expanded: false,
})

export const backgroundFolder = pane.addFolder({
  title: "Background",
  expanded: false,
})

export const lightsFolder = pane.addFolder({
  title: "Lights",
  // expanded: false,
})

export const tShirtFolder = pane.addFolder({
  title: "TShirt",
  // expanded: false,
})

export const jacketFolder = pane.addFolder({
  title: "Jacket",
  // expanded: false,
})

export const cloudsFolder = pane.addFolder({
  title: "Clouds",
})

// export const debugObject = {
//   crystalColor: "#70ffe3",
//   backgroundColor1: "#362f24",
//   backgroundColor2: "#040213",
//   globalLightColor: "#ffffff",
//   accentLightColor: "#3737ff",
//   turnTableSpeeds: 1,
//   jacketColor1: "#6f61ff",
//   jacketColor2: "#8dc1f6",
//   jacketColor3: "#e272e0",
//   jacketColor4: "#d7b0f6",
// }

export const debugObject = {
  crystalColor: "#70ffe3",
  backgroundColor1: "#0f2026",
  backgroundColor2: "#040213",
  globalLightColor: "#c882bf",
  accentLightColor: "#26658f",
  turnTableSpeeds: 1,
  jacketColor1: "#433aa8",
  jacketColor2: "#418dc8",
  jacketColor3: "#e589e3",
  jacketColor4: "#c5c5c5",
  cloudsColor: "#ffffff",
}

export const canvas = document.querySelector("canvas.webgl")

export const loadingScreen = new LoadingScreen()

export const scene = new THREE.Scene()

export const stencilScene = new THREE.Scene()

export const loaders = new Loaders()

export const deviceStateManager = new DeviceStateManager()

export const environment = new Environment()
scene.background = new THREE.Color(0)

export const garmentManager = new GarmentManager()

export const garments = new Garments()

export const garmentJacket = new GarmentJacket()

export const garmentTShirt = new GarmentTShirt()

export const patch = new Patch()

export const overlay = new Overlay()

export const lights = new Lights()

export const environmentParticles = new EnvironmentParticles()

export const background = new Background()

export const grain = new Grain()

export const sizes = new Sizes()

export const camera = new Camera()

export const renderer = new Renderer()

export const postProcessing = new PostProcessing()

//Scroll to top on refresh
window.onbeforeunload = () => {
  window.scrollTo(0, 0)

  // For Safari ?
  document.documentElement.scrollTop
}

// window.addEventListener("scroll", scrollToTop)

//Animate
const clock = new THREE.Clock()
let time = Date.now()

const tick = () => {
  // stats.begin()

  const elapsedTime = clock.getElapsedTime()

  const currentTime = Date.now()
  const deltaTime = currentTime - time
  time = currentTime

  if (overlay.overlay) overlay.update(elapsedTime)

  // Multiply by deltaTime for the animation to play at the same speed at every frame rate
  if (garmentTShirt.mixer) garmentTShirt.mixer.update(0.001 * deltaTime)

  if (garments.hoodie) {
    if (patch.patchParticlesPoints) {
      patch.update(elapsedTime)
      garments.copyShadersToMeshes()
    }

    garments.rotateCrystal(elapsedTime)
  }

  // environment.floor.material.update()
  environmentParticles.update(elapsedTime)

  background.update(elapsedTime)

  garmentJacket.update(elapsedTime)

  grain.update(elapsedTime)

  // Update controls
  // camera.controls.update()
  if (deviceStateManager.state === "desktop") camera.update()

  // Render
  renderer.renderer.render(scene, camera.camera)
  // postProcessing.effectComposer.render()

  // setTimeout(() => {
  window.requestAnimationFrame(tick)
  // }, 1000 / 60)

  // stats.end()

  window.addEventListener("resize", onWindowResize)
}

function onWindowResize() {
  const width = window.innerWidth
  const height = window.innerHeight

  camera.camera.aspect = width / height
  camera.camera.updateProjectionMatrix()

  renderer.renderer.setSize(width, height)
  postProcessing.effectComposer.setSize(width, height)
}

tick()
